<div class="modal-header wk-add-edit__header">
    <h3 class="modal-title wk-add-edit__header-title">{{ title | translate }}</h3>
    <wk-icon-filled-close-sprite-pds3> </wk-icon-filled-close-sprite-pds3>
    <icon-pds3 name="wk-icon-filled-close" color="#fff" (click)="bsModalRef.hide()" class="wk-add-edit__header-icon"></icon-pds3>
</div>
<div cg3-theme="PDS-v3" class="modal-body wk-add-edit__body">
    <div class="wk-add-edit__form">
        <div class="wk-add-edit__form-input">
            <label class="wk-add-edit__form-label">{{ "Settings.Name_EN" | translate }}</label>
            <text-field-pds3 class="wk-add-edit__form-text-field">
                <input
                    type="text"
                    title=""
                    required
                    name="descriptionEN"
                    #descriptionEN="ngModel"
                    [(ngModel)]="data.Name['en-CA']"
                    (keyup.enter)="submitForm()"
                    maxlength="50"
                />
            </text-field-pds3>
        </div>

        <div class="wk-add-edit__form-input">
            <label class="wk-add-edit__form-label">{{ "Settings.Name_FR" | translate }}</label>
            <text-field-pds3 class="wk-add-edit__form-text-field">
                <input
                    type="text"
                    title=""
                    required
                    name="descriptionFR"
                    #descriptionEN="ngModel"
                    [(ngModel)]="data.Name['fr-CA']"
                    (keyup.enter)="submitForm()"
                    maxlength="50"
                />
            </text-field-pds3>
        </div>
    </div>
    <div class="wk-add-edit__actions">
        <button
            class="btn-primary wk-add-edit__actions-save"
            (click)="submitForm()"
            [disabled]="data.Name['en-CA'].trim().length === 0 || data.Name['fr-CA'].trim().length === 0"
        >
            {{ "Settings.Save" | translate }}
        </button>
        <button class="btn-secondary wk-add-edit__actions-cancel" (click)="bsModalRef.hide()">{{ "Settings.btnCancel" | translate }}</button>
    </div>
</div>
